import { COLORS } from '@btime/constants'
import { propOr } from 'ramda'
import { useFilter, useFilterActions } from '@btime/react-contexts'
import React from 'react'

import { ALL, DONE, IGNORED, OPEN } from '../../../../utils/constants/status'
import { useStatusOptionFormatter } from '../../../../utils/helpers/status'
import TabsMenu, { Tab } from '../../../../components/tabs/TabsMenu'

const fastFilterStatuses = [ALL, OPEN, DONE]

const FastFilters = () => {
  const formatStatus = useStatusOptionFormatter()
  const filter = useFilter()
  const { setFilterAndTempFilterValue } = useFilterActions()
  const selectedStatus = propOr(ALL, 'statuses', filter)
  if (!selectedStatus) {
    setFilterAndTempFilterValue('statuses', ALL)
  }

  return (
    <TabsMenu>
      {fastFilterStatuses.map(statusName => {
        const active = statusName === selectedStatus
        const option = formatStatus(statusName)
        const isAll = statusName === ALL

        return !isAll ? (
          <Tab
            key={statusName}
            useButtonStyle
            color={active ? COLORS.purple : COLORS.dark3}
            active={active}
            onClick={() => setFilterAndTempFilterValue('statuses', statusName)}
          >
            {option.label}
          </Tab>
        ) : (
          <Tab
            key={statusName}
            useButtonStyle
            color={active ? COLORS.purple : COLORS.dark3}
            active={active}
            onClick={() => setFilterAndTempFilterValue('statuses', '')}
          >
            {option.label}
          </Tab>
        )
      })}
    </TabsMenu>
  )
}

export default FastFilters
